function setCacheHas(value) {
  return this.__data__.has(value);
}
export {
  setCacheHas as default
};
